import { Menu, MenuItemLink, MenuProps, useLogout, useSidebarState, useTranslate } from 'react-admin';
import { useDataProvider } from 'react-admin';
import { useEffect, useState, useCallback } from 'react';
import CastIcon from '@mui/icons-material/Cast';
import HomeIcon from '@mui/icons-material/Home';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import InventoryIcon from '@mui/icons-material/Inventory';
import CreditCardIcon from '@mui/icons-material/CreditCard';

import { Box } from '@mui/material';
import SubMenu from './SubMenu';
import { MenuConstant } from './MenuContant';
import { getDefaultExpendAllByMenu } from '../utils/tool';
import clsx from 'clsx';

const menus = MenuConstant;

export const MyMenu = ({ dense = false }: MenuProps) => {
    const [open] = useSidebarState();
    const translate = useTranslate();
    const logout = useLogout();
    const [userRole, setUserRole] = useState('');
    const [filteredMenus, setFilteredMenus] = useState<any[]>([]);
    const [expandedStates, setExpandedStates] = useState<Record<string, boolean>>({});

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const role = localStorage.getItem("permissions");
                if (!role) {
                    logout()
                }
                setUserRole(role);

                // 过滤菜单项
                const filtered = filterMenuByPermission(menus, role);
                setFilteredMenus(filtered);

                // 初始化展开状态
                const initialExpandedStates = getDefaultExpendAllByMenu(filtered);
                setExpandedStates(initialExpandedStates);
            } catch (error) {
                console.error('获取用户信息失败:', error);
            }
        };

        fetchUserInfo();
    }, []);

    const filterMenuByPermission = (menuList: any[], role: string): any[] => {
        return menuList
            .map(menu => {
                // 检查权限
                if (menu.permission && !menu.permission.includes(role)) {
                    return null;
                }

                // 如果有子菜单，递归过滤
                if (menu.children && menu.children.length > 0) {
                    const filteredChildren = filterMenuByPermission(menu.children, role);

                    // 如果所有子菜单都没有权限，则不显示父菜单
                    if (filteredChildren.length === 0) {
                        return null;
                    }

                    return {
                        ...menu,
                        children: filteredChildren
                    };
                }

                return menu;
            })
            .filter(menu => menu !== null);
    };

    const handleToggle = useCallback((menuId: string) => {
        setExpandedStates(prev => ({ ...prev, [menuId]: !prev[menuId] }));
    }, []);

    const getMenuNode = useCallback((list: any[], depth = 0) => {
        return list.map((value: any, key: any) => {
            if (value.children && value.children.length > 0) {
                return (
                    <SubMenu
                        depth={depth}
                        handleToggle={() => handleToggle(value.id)}
                        isOpen={expandedStates[value.id]}
                        name={translate(value.title) || value.title}
                        icon={convertIcon(value.icon)}
                        dense={false}
                        key={key}
                    >
                        {getMenuNode(value.children, depth + 1)}
                    </SubMenu>
                )
            } else {
                return (
                    <MenuItemLink
                        to={value.url}
                        state={{ _scrollToTop: true }}
                        primaryText={translate(value.title) || value.title}
                        leftIcon={convertIcon(value.icon)}
                        key={key}
                        sx={{
                            paddingLeft: `${30 + 20 * depth}px`,
                            fontSize: theme => theme.typography.body2.fontSize * (1 - 0.05 * depth),
                        }}
                    />
                )
            }
        });
    }, [expandedStates, handleToggle, translate]);

    if (!userRole) {
        return <Box sx={{ width: open ? 200 : 50 }}>Loading...</Box>;
    }

    return (
        <Box sx={{
            width: open ? 200 : 50,
            marginTop: 0,
            marginBottom: 0,
            transition: (theme) =>
                theme.transitions.create("width", {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
        }}
            className={clsx({
                'RaMenu-open': open,
                'RaMenu-closed': !open,
            })}>
            <Box>
                {getMenuNode(filteredMenus)}
            </Box>
        </Box>
    );
};

const convertIcon = (icon: string) => {
    switch (icon) {
        case "HomeIcon":
            return <HomeIcon />;
        case "CastIcon":
            return <CastIcon />;
        case "DisplaySettingsIcon":
            return <DisplaySettingsIcon />;
        case "PrecisionManufacturingIcon":
            return <PrecisionManufacturingIcon />;
        case "DirectionsRunIcon":
            return <DirectionsRunIcon />;
        case "InventoryIcon":
            return <InventoryIcon />;
        case "CreditCard":
            return <CreditCardIcon />;
        default:
            return null;
    }
}